// extracted by mini-css-extract-plugin
module.exports = {"square":"utils_square__jG32U","portrait":"utils_portrait__P1ycA","landscape":"utils_landscape__kOXnZ"};